import { UseQueryOptions } from '@tanstack/react-query'

import { ApiError } from '@mangovoice/types'

export enum IdOrderingFilter {
  ASCENDING = 'id',
  DESCENDING = '-id',
}

// #region Voicemail Request Types
export enum UnreadVoicemailStatusFilter {
  ALL = 'unknown',
  TRUE = 'true',
  FALSE = 'false',
}

export interface GetVoicemailsRequest {
  pbxId: number | string
  extensionId?: number | string
  search?: string
  offset?: number
  limit?: number
  unread?: UnreadVoicemailStatusFilter
}
// #endregion

// #region Fax Request Types
export enum FaxDirectionFilter {
  ALL = '',
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
}
export interface GetFaxListRequest {
  pbxId?: number | string
  offset?: number | string
  search?: string
  direction?: FaxDirectionFilter
  ordering?: IdOrderingFilter
  extension_id?: number | string
  unread?: boolean
  limit?: number
}
// #endregion

// #region Snippet Request Types
export interface GetSnippetsRequest {
  pbxId?: number
  offset?: number | string
  personal?: boolean
}
// #endregion

export type QueryCancellation = () => void
export type AsyncQueryCancellation = () => Promise<void>

export type UseQueryParameters<TQueryResult, TQueryParameters = unknown> = {
  onQueryStarted?: () => void
  onQuerySuccess?: (data: TQueryResult) => void
  onQueryCancelled?: () => void
  onQueryError?: (error?: ApiError, queryParams?: TQueryParameters) => void
  options?: Omit<UseQueryOptions<TQueryResult, ApiError>, 'queryKey'>
}
